export default __webpack_public_path__ + "static/media/69423b7cc5c7a22e36e414e8c61a593a1583950243725.6ecf51bb.webp";